module.exports = __webpack_public_path__ + "static/media/promo-image-en.13b4d058.jpg";